export default "__VITE_ASSET__BAuptlQ___"